import { useMemo, VFC } from 'react';
import { hesselViewModels } from '../../../../lib/view-models';
import { CollapsibleItem } from '../collapsible-item';
import { StyledHeader, StyledLi, StyledText, StyledUl } from '../equipment-dialog.styled';
import { StyledContainer, StyledEquipmentPackage, StyledPackagesContainer } from './included-equipment-package.styled';

type IncludedEquipmentPackageProps = {
    includedPackageIdKeys: string[];
    equipmentPackages: hesselViewModels.EquipmentPackage[];
};

export const IncludedEquipmentPackage: VFC<IncludedEquipmentPackageProps> = ({ includedPackageIdKeys, equipmentPackages }) => {
    const filteredEquipmentPackages = useMemo(() => {
        const includedEquipment = equipmentPackages.filter((e) => {
            return includedPackageIdKeys.includes(e.packageIdKey);
        });

        return includedEquipment;
    }, [includedPackageIdKeys, equipmentPackages]);

    if (!filteredEquipmentPackages.length) {
        return null;
    }

    return (
        <StyledContainer>
            <StyledHeader>ANDET INDHOLD</StyledHeader>
            <StyledPackagesContainer>
                {filteredEquipmentPackages.map((e) => (
                    <StyledEquipmentPackage key={`equipment-package-${e.id}`}>
                        <StyledHeader>{e.name}</StyledHeader>
                        <StyledUl>
                            {e.equipment.map((stdEqpPackage, index) => {
                                return (
                                    <StyledLi key={`standard-equipment-package-item-${stdEqpPackage.id}-${e.id}:${index}`}>
                                        {!stdEqpPackage.description ? (
                                            <StyledText>{stdEqpPackage.name}</StyledText>
                                        ) : (
                                            <CollapsibleItem
                                                name={stdEqpPackage.name}
                                                description={stdEqpPackage.description}
                                                resources={stdEqpPackage.resources}
                                            />
                                        )}
                                    </StyledLi>
                                );
                            })}
                        </StyledUl>
                        {!!e?.includedPackageIdKeys && (
                            <IncludedEquipmentPackage includedPackageIdKeys={e.includedPackageIdKeys} equipmentPackages={equipmentPackages} />
                        )}
                    </StyledEquipmentPackage>
                ))}
            </StyledPackagesContainer>
        </StyledContainer>
    );
};
